import React from 'react';

const commonText = {
  frequencyText: 'Frequency',
  frequencyTooltip: 'Provide an optional maximum number of impressions to deliver per target',
  percentText: 'Percent of Buy',
  percentTooltip: <span>
    Force a specific percentage of your overall budget to be spent in this mode by selecting "Exact" and entering a percentage between 1 and 100.
    <br /><br />
    Set a limit on the maximum percentage of your overall budget to be spent in this mode by selecting "Max" and entering a percentage between 1 and 100.
  </span>,
  impactFactorText: <span>
                      <span className='cca-slider-minus'>-</span>
                      <span className='cca-slider-plus'>+</span>
                      <span className='cca-slider-center-text'>Relative Impact</span>
                    </span>,
  impactFactorTooltip: 'Move the slider to adjust the impact of this mode of contact relative to any other selected modes.  Default settings represent normally accepted impact levels for each mode.',
  discountText: '',
  discountTooltip: 'How quickly the impact of additional impressions received in a mode decays with the number of times targets have successfully been contacted in the mode already. (Lower numbers mean faster decrease)',
  flightText: 'Mail flight size',
  flightTooltip: 'Specify the number of mail pieces in a full flight of mail for the campaign',
};

export default commonText;
